import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { inLabel } from "./styles_vanilla.css";

const PositionName = ({
  account,
  entity,
}: {
  account?: string | null;
  entity?: string | null;
}) => {
  return (
    <Flex flexDirection="row" gap={Sizes.XS}>
      <Text variant="regular-md">{account ?? "--"}</Text>
      <Text variant="regular-md" className={inLabel}>
        in
      </Text>
      <Text variant="regular-md">{entity ?? "--"}</Text>
    </Flex>
  );
};
export default PositionName;
